import React from "react";

const Title = () => {
    return (
          <h1 className="title">Главный заголовок</h1>
    );
}

export default Title
